// / <reference types="vite/client" />

import axios, { type AxiosError, type AxiosInstance, type InternalAxiosRequestConfig } from "axios";

import { checkTokenIsValid } from "~/Core/Hooks/utils/helpers";
import { HttpStatusCodes } from "~/Models/enums";

const baseURL = import.meta.env.VITE_API_URL;
const tokenKey = "Account";

const instance: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
});

const setAuthorizationHeader = (config: InternalAxiosRequestConfig<any>) => {
  const token = JSON.parse(localStorage.getItem(tokenKey) ?? null)?.state?.UserProfile?.profile?.token as string;
  if (!token) return;
  if (checkTokenIsValid(token)) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
    localStorage.removeItem(tokenKey);
    window.location.reload();
  }

  config.headers["Accept-Language"] = "en";
};

const handleUnauthorizedError = (error: AxiosError) => {
  if (error?.response?.status === HttpStatusCodes.Unauthorized) {
    console.log(error.response);
  }
};

const handleInternalServerError = (error: AxiosError) => {
  if (error?.response?.status === HttpStatusCodes.InternalServerError) {
    console.log(`something went wrong ! ${import.meta.env.VITE_DEBUG_MODE === "true" ? error?.response?.data?.ErrorMessage : ""}`);
  }
};

const handleTokenExpiredError = (error: AxiosError) => {
  if ((error?.response?.data?.toString()?.indexOf("SecurityTokenExpiredException") ?? -1) > -1) {
    console.log("Token Expired");
    localStorage.removeItem(tokenKey);
    window.location.reload();
  }
};

instance.interceptors.request.use(config => {
  setAuthorizationHeader(config);
  return config;
});

instance.interceptors.response.use(
  response => response,
  error => {
    handleUnauthorizedError(error);
    handleInternalServerError(error);
    handleTokenExpiredError(error);
    return Promise.reject(error);
  },
);

export default {
  delete: instance.delete,
  get: instance.get,
  instance,
  patch: instance.patch,
  post: instance.post,
  put: instance.put,
};
